import type { TenantConfig } from '@/types/TenantConfig'

const red = '#D62027'
const black = '#231f20'
const gray = '#939598'
const lightGray = '#f1f2f2'

export const easternstate: TenantConfig = {
  logo: 'assets/easternstate/static/logo.svg',
  teaserImageSize: {
    width: 320,
  },
  themeOptions: {
    primaryColor: red,
    secondaryColor: black,
    logoHeight: '80px',
    headerHeight: '100px',
    cartHeaderBackgroundColor: black,
    memberLinksColor: red,
    footerBackgroundColor: gray,
    footerTextColor: 'white',
  },
  componentOptions: {
    completedOrdersRoute: {
      completedImage: {
        desktop: 'assets/easternstate/static/completed.jpeg',
      },
      completedContentOffset: {
        desktop: '-240px',
        mobile: '-130px',
      },
    },
  },
}
